/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Ask Wundo anything…" |
*
* @param {Chat_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_placeholder = /** @type {((inputs?: Chat_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vraag iets aan Wundo…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demandez à Wundo…")
	return /** @type {LocalizedString} */ ("Ask Wundo anything…")
});